/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import MySkeleton from '../../../../components/Skeleton';
import { ChatAvatarStyles } from '../../../../utils/muiStyle';
import { getUserDetails } from '../../../../utils/orgName';
import { alphaColorsNew } from '../../../../utils/alphabates-colors';
// import redOnlineDot from '../../../../assets/images/redOnlineDot.svg';
import greenOnlineDot from '../../../../assets/images/greenOnlineDot.svg';

/**
 * Chat avatar component
 */
interface IChatAvatarComponent {
  image?: string | null | undefined;
  firstLetter?: any;
  onClickOnUserIcon?: () => void;
  width?: string;
  height?: string;
  type?: 'self' | 'other' | 'home' | 'noStatus';
  fontSize?: string;
  border?: string;
  cursor?: string;
  loading?: boolean;
  variant?: 'circle' | 'rectangle';
}

const ChatAvatarComponent: React.FC<IChatAvatarComponent> = ({
  image,
  firstLetter,
  onClickOnUserIcon,
  width = '50px',
  height = '50px',
  type = 'other',
  fontSize,
  border = 'none',
  cursor = '',
  loading,
  variant = 'circle'
}) => {
  const userFirstLetter = getUserDetails()?.name?.slice(0, 1);
  const classes = ChatAvatarStyles({ variant: variant, loading: loading, border: border });
  const [imgError, setImgError] = useState(false);
  // A new photo gets a new URL, so give it a fresh chance to load.
  useEffect(() => setImgError(false), [image]);

  /** Online offline status check */
  const onlineOfflineStatus = greenOnlineDot; // redOnlineDot
  /** Set type to 'noStatus' if loading is true */
  const avatarType = loading ? 'noStatus' : type;

  const showImage = _.size(image) && !imgError;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" position="relative">
      <Box
        onClick={onClickOnUserIcon}
        className={onClickOnUserIcon || cursor === 'pointer' ? 'cursor-pointer' : ''}
        position="relative"
        justifyContent="center"
        alignItems="center"
        display="flex"
        bgcolor={showImage || loading ? 'transparent' : _.get(alphaColorsNew, _.capitalize(firstLetter?.charAt(0)), '')}
        width={width}
        height={height}
        border={showImage || loading ? '' : border}
        borderRadius={variant === 'circle' ? '50%' : '8px'}
      >
        {loading ? (
          <MySkeleton
            width={width}
            height={height}
            border={border}
            variant={variant === 'circle' ? 'circular' : 'rounded'}
          />
        ) : showImage ? (
          <img
            src={image || ''}
            alt=""
            className={classes.avatarImg}
            loading="lazy"
            decoding="async"
            referrerPolicy="no-referrer"
            onError={() => setImgError(true)}
          />
        ) : (
          <>
            {avatarType === 'self' ? (
              <Typography color="inherit">{_.capitalize(userFirstLetter)}</Typography>
            ) : (
              <Typography color="#FFFFFF" fontWeight="600" fontSize={fontSize ? fontSize : '16px'}>
                {firstLetter?.toUpperCase()}
              </Typography>
            )}
          </>
        )}
      </Box>

      {/* Online offline Dot */}
      {avatarType !== 'noStatus' && (
        <img src={onlineOfflineStatus} alt="" width="10px" height="10px" className={classes.noStatus} />
      )}
    </Box>
  );
};

export default ChatAvatarComponent;
